export function resetAnswer(question, prop) {
    question[prop] = {
        content: "",
        answer: "**【答案】** ",
        answer_fenxi: "**【分析】** ",
        answer_xiangjie: "**【详解】** ",
        comment: "**【点评】** ",
    };
}

export function resetQuestionStandardAnswer(question) {
    question.standardAnswer = {
        content: "",
    };
    if (['MCQ', 'TF', 'SCQ'].includes(question.question_type)) {
        resetAnswer(question, "standardAnswer");
    }
}
